<template>
  <div class="front_blog">
    <div class="container">
      <div class="front_blog_content">
        <div class="head">
          <div class="en">BLOGS</div>
          <div class="ja">最新情報</div>
        </div>
        <div class="content">
          <div class="item" v-for="item in latest" :key="item.id">
            <a :href="'./post.php?id=' + item.id" class="archive_item">
              <div class="photo">
                <img :src="item.image_file_name" alt="" class="img" />
              </div>
              <div class="categories">
                <div class="cat" v-for="cat in item.categories" :key="cat.id">
                  {{ cat.name }}
                </div>
              </div>
              <div class="title">{{ item.title }}</div>
              <div class="date">
                {{ item.published_at.substr(0, 10) }}
              </div>
            </a>
          </div>
        </div>
        <div class="more">
          <a href="./blog.php" class="link">MORE</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import 'hooper/dist/hooper.css';

export default {
  components: {},
  data() {
    return {
      latest: [],
    };
  },
  mounted() {
    axios({
      method: 'get',
      url: 'https://admin.renodeluxe.jp/api/blogs',
    }).then((data) => {
      for (let i = 0; i < 3; i++) {
        this.latest.push(data.data[i]);
      }
    });
  },
  methods: {
    next() {
      this.$refs.blogs.slideNext();
    },
    prev() {
      this.$refs.blogs.slidePrev();
    },
  },
};
</script>
<style lang="scss" scoped>
.front_blog {
  // background: #a34652;
  padding: 90px 30px;
  > .container {
    width: 100%;
    max-width: 1020px;
    margin: 0 auto;
    background: transparent;
  }
}

.front_blog_content {
  color: #1a1a1a;
  > .head {
    text-align: center;
    position: relative;
    &::before,
    &::after {
      content: '';
      display: block;
      width: 240px;
      height: 1px;
      background: #1a1a1a;
      position: absolute;
      top: 50%;

      @media #{$phone} {
        width: 25%;
      }
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }

    > .en {
      font-size: 3.2rem;
    }
  }
  > .content {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    gap: 20px;

    @media #{$phone} {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      gap: 20px;
      position: relative;
    }

    &:not(:first-child) {
      padding-top: 20px;
      margin-top: 20px;
      &::before {
        content: '';
        width: 45%;
        height: 1px;
        background: #9fb4bc;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .archive_item {
      display: block;
      padding: 15px;
      background: #fff;
      height: 100%;
      box-shadow: 0px 3px 5px rgba(#000, 0.1);
      color: #1a1a1a;
      text-decoration: none;
      > .photo {
        display: block;
        width: 100%;
        padding-bottom: 70%;
        position: relative;
        > .img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          object-fit: cover;
        }
      }
      > .categories {
        margin-top: 10px;
        > .cat {
          display: inline-block;
          padding: 5px 10px;
          color: #fff;
          background: #1a1a1a;
          &:not(:first-child) {
            margin-left: 10px;
          }
        }
      }
      > .title {
        font-size: 1.2em;
        margin-top: 10px;
      }
      > .date {
        color: #757575;
        margin-top: 10px;
      }
    }
  }
  > .more {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    // visibility: hidden;
    > .link {
      display: inline-block;
      padding: 10px 45px;
      background: #fff;
      color: #1a1a1a;
      font-size: 2rem;
      font-weight: bold;
      font-style: italic;
      text-decoration: none;
      letter-spacing: 2px;
      transition: 0.3s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

.hooper {
  height: auto;
}

.slide_item {
  > .thumb {
    display: block;
    width: 100%;
    border: 3px solid #fff;
    background-size: cover;
    background-position: center;
    margin-top: 60px;
    &::after {
      content: '';
      display: block;
      width: 100%;
      padding-bottom: calc(9 / 20 * 100%);
    }
  }

  > .categories {
    visibility: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 20px;
    > .item {
      display: inline-block;
      padding: 5px 30px;
      color: #fff;
      background: #1a1a1a;
      margin: 10px;
      font-size: 2rem;
      letter-spacing: 1px;

      // &.work {
      //   background: #4c9898;
      // }

      // &.lifestyle {
      //   background: #754651;
      // }

      // &.visit {
      //   background: #a47f53;
      // }

      // &.item {
      //   background: #9fb4bc;
      // }
    }
  }

  > .title {
    text-align: center;
    font-size: 2.8rem;
    visibility: hidden;

    @media #{$phone} {
      font-size: 2rem;
    }
  }
}

.is-current {
  .title,
  .more,
  .categories,
  .more {
    visibility: visible;
  }
}

.slide_wrapper {
  position: relative;
  > .arrow {
    cursor: pointer;
    position: absolute;
    top: 42%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    z-index: 10;

    @media #{$phone} {
      display: none;
    }

    &.prev {
      left: 40px;
      transform: translateY(-50%) scale(-1);
    }

    &.next {
      right: 40px;
    }
  }
}
</style>
